import { useEffect, useState } from "react";
import { dateTimeBR } from "../lib/format";

export function useNow(intervalMs = 1000): string {
  const [now, setNow] = useState(() => dateTimeBR(new Date()));
  useEffect(() => {
    const t = setInterval(() => setNow(dateTimeBR(new Date())), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}
